import { cn } from "@/lib/utils";
import { Button } from "@/styles/ui/button";
import { SquareFunction } from "lucide-react";

const AutoSumToggle = ({
  useAutoSum,
  setUseAutoSum,
}: {
  useAutoSum: boolean;
  setUseAutoSum: (useAutoSum: boolean) => void;
}) => {
  return (
    <div className="flex items-center flex-shrink-0 gap-[8px] justify-end">
      <span className="caption-1-medium text-[#737373]">합계 자동계산</span>
      <Button
        onClick={() => setUseAutoSum(!useAutoSum)}
        className={cn(
          "overflow-clip relative rounded-[100px] w-[44px] h-[24px] transition-all duration-200 ",
          "hover:bg-neutral-300 ",
          // 토글 상태에 따른 배경색 변경
          useAutoSum ? "bg-blue-200 hover:bg-blue-300" : "bg-neutral-200",
        )}
        data-name="합계 토글버튼"
      >
        {/* 토글 스위치의 슬라이더 */}
        <div
          className={cn(
            "absolute left-0.5 overflow-clip rounded-[100px]  top-1/2 translate-y-[-50%] transition-transform duration-200 flex items-center w-[20px] h-[20px] justify-center",
            useAutoSum ? "translate-x-[20px] bg-blue-500" : "bg-neutral-400",
          )}
        >
          <SquareFunction className={cn("p-[3px] text-white")} />
        </div>
      </Button>
    </div>
  );
};

export default AutoSumToggle;
